import React from "react";
// import moment from "moment";
import ListItemText from "@material-ui/core/ListItemText";

const ResumenDeProyecto = ({ project }) => {

  return <ListItemText secondary={project.title} />;
};

export default ResumenDeProyecto;
